let router = [
    {
        path: '/marketing/coupon',
        name: 'list',
        component: () => import('@/views/marketing/coupon/list.vue'),
        meta: {keepAlive: true, parentPath: 'marketing'},
    },
    {
        path: '/marketing/coupon/edit',
        name: 'edit',
        component: () => import('@/views/marketing/coupon/edit.vue'),
        meta: {keepAlive: true, parentPath: 'marketing'},
    },
    {
        path: '/marketing/coupon/goods',
        name: 'goods',
        component: () => import('@/views/marketing/coupon/goods.vue'),
        meta: {keepAlive: true, parentPath: 'marketing'},
    },
    {
        path: '/marketing/coupon/record',
        name: 'record',
        component: () => import('@/views/marketing/coupon/record.vue'),
        meta: {keepAlive: true, parentPath: 'marketing'},
    }
]
export default router


// WEBPACK FOOTER //
// ./src/router/marketing.js